import {createRouter, createWebHashHistory} from 'vue-router'
import HomePageView from "@/components/HomePageView/HomePageView.vue";
import CatalogView from "@/components/CatalogView/CatalogView.vue";
import ProductCardView from "@/components/ProductCardView/ProductCardView.vue";
import ClubView from "@/components/ClubView/ClubView.vue";
import ClubSignUpView from "@/components/ClubSignUpView/ClubSignUpView.vue";
import ClubSignUpFinishView from "@/components/ClubSignUpView/ClubSignUpFinishView.vue";
import SignInView from "@/components/SignInView/SignInView.vue";
import SignUpStep1View from "@/components/SignUpView/SignUpStep1View.vue";
import SignUpStep2View from "@/components/SignUpView/SignUpStep2View.vue";
import SignUpFinishView from "@/components/SignUpView/SignUpFinishView.vue";
import CartView from "@/components/CartView/CartView.vue";
import {useAuthStore} from "@/store/auth";
import {useSettingsStore} from "@/store/settings";
import CheckoutView from "@/components/CheckoutView/CheckoutView.vue";
import CheckoutFinishView from "@/components/CheckoutFinishView/CheckoutFinishView.vue";
import CheckoutFinishErrorView from "@/components/CheckoutFinishView/CheckoutFinishErrorView.vue";
import PersonalAccountView from "@/components/PersonalAccount/PersonalAccountView.vue";
import ContactsView from "@/components/PersonalAccount/ContactsView/ContactsView.vue";
import OrdersView from "@/components/PersonalAccount/OrdersView/OrdersView.vue";
import ConsentView from "@/components/ConsentView/ConsentView.vue";
import ActivationView from "@/components/ActivationView/ActivationView.vue";
import ResetPasswordView from "@/components/ResetPasswordView/ResetPasswordView.vue";
import ChangePasswordView from "@/components/ChangePasswordView/ChangePasswordView.vue";
import AdminView from "@/components/AdminView/AdminView.vue";

const warehouseRoutes = [{
    path: '/',
    redirect: '/home',
}, {
    path: '/home',
    name: 'HomePage',
    component: HomePageView,
}, {
    path: '/catalog',
    name: 'CatalogView',
    component: CatalogView,
}, {
    path: '/product',
    props: route => Object.assign({}, route.query, route.params),
    name: 'ProductCardView',
    component: ProductCardView,
}, {
    path: '/club',
    name: 'ClubView',
    component: ClubView,
}, {
    path: '/club-signup',
    name: 'ClubSignUpView',
    component: ClubSignUpView,
    meta: {
        privatePath: true
    }
}, {
    path: '/club-signup-finish',
    name: 'ClubSignUpFinishView',
    component: ClubSignUpFinishView,
    meta: {
        privatePath: true
    }
}, {
    path: '/login',
    name: 'SignInView',
    component: SignInView,
}, {
    path: '/signup',
    name: 'SignUpStep1View',
    component: SignUpStep1View,
}, {
    path: '/signup2',
    name: 'SignUpStep2View',
    component: SignUpStep2View,
}, {
    path: '/signup-finish',
    name: 'SignUpFinishView',
    component: SignUpFinishView,
},{
    path: '/cart',
    name: 'CartView',
    component: CartView,
    meta: {
        privatePath: true
    }
},{
    path: '/checkout',
    name: 'CheckoutView',
    component: CheckoutView,
    meta: {
        privatePath: true
    }
},{
    path: '/checkout-finish',
    name: 'CheckoutFinishView',
    component: CheckoutFinishView,
},{
    path: '/checkout-finish-error',
    name: 'CheckoutFinishErrorView',
    component: CheckoutFinishErrorView,
}, {
    path: '/lk',
    name: 'PersonalAccount',
    component: PersonalAccountView,
    meta: {
        privatePath: true
    },
    children: [{
        path: '/',
        redirect: { name: "ContactView"}
    },{
        path: '/contacts',
        name: 'ContactsView',
        component: ContactsView,
        meta: {
            privatePath: true,
        }
    },{
        path: '/orders',
        name: 'OrdersView',
        component: OrdersView,
        meta: {
            privatePath: true,
        }
    }
    ]
},{
    path: '/consent-info',
    name: 'ConsentInfo',
    component: ConsentView,
},{
    path: '/consent-personal',
    name: 'ConsentPersonal',
    component: ConsentView,
},{
    path: '/consent-club',
    name: 'ConsentClub',
    component: ConsentView,
},{
    path: '/consent-confidential',
    name: 'ConsentConfidential',
    component: ConsentView,
},{
    path: '/activation',
    name: 'ActivationView',
    props: route => Object.assign({}, route.query, route.params),
    component: ActivationView,
},{
    path: '/reset-password',
    name: 'ResetPasswordView',
    component: ResetPasswordView,
},{
    path: '/change-password',
    name: 'ChangePasswordView',
    props: route => Object.assign({}, route.query, route.params),
    component: ChangePasswordView,
},{
    path: '/admin',
    name: 'AdminView',
    component: AdminView,
    meta: {
        privatePath: true,
        requiresRoles: ['admin', 'superadmin']
    }
}
];

let router = null;

export default function createMainRouter() {
    router = createRouter({
        history: createWebHashHistory(),
        routes: warehouseRoutes,
    });
    router.afterEach(() => {
        window.scrollTo(0, 0);
    });
    router.beforeEach(async (to, from, next) => {
        const isPublicPage =  !to.meta?.privatePath;
        const authStore = useAuthStore();
        if(!authStore.initialized) {
            await authStore.initStore()
        }
        if (!isPublicPage && !authStore.userId) {
            console.log('goto login Page');
            await router.push({ name: 'SignInView' });
        }
        const requiresRoles = to.meta?.requiresRoles;
        if (authStore.userId && requiresRoles?.length) {
            const settingsStore = useSettingsStore();
            if (!settingsStore.hasAnyRole(requiresRoles)) {
                console.log('access denied by roles', requiresRoles);
                await router.push({ name: 'HomePage' });
                return;
            }
        }
        next();
    })
    return router;
}


